/** Dependencies */
import OperationLogsDetails from './OperationLogsDetails';
import OperationLogsWizard from './OperationLogsWizard';

export { OperationLogsWizard };

export default OperationLogsDetails;
